/* ============================================================
   Tasty Flavours — Product Page (PDP) interactions
   Qty stepper, AJAX add-to-cart + cart-drawer, gallery,
   accordions, mobile sticky CTA. No dependencies.
   ============================================================ */
(function () {
  'use strict';

  /* Gedeelde toast (rechtsboven). Eén instantie voor de hele pagina. */
  function tfToast(msg) {
    if (window.__tfToastFn) { window.__tfToastFn(msg); return; }
    var wrap = document.createElement('div');
    wrap.className = 'tf-toast-wrap';
    document.body.appendChild(wrap);
    window.__tfToastFn = function (m) {
      var t = document.createElement('div');
      t.className = 'tf-toast';
      t.setAttribute('role', 'status');
      t.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg><span></span>';
      t.querySelector('span').textContent = m || 'Toegevoegd aan winkelwagen';
      wrap.appendChild(t);
      requestAnimationFrame(function () { t.classList.add('is-in'); });
      setTimeout(function () {
        t.classList.remove('is-in'); t.classList.add('is-out');
        setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 380);
      }, 2600);
    };
    window.__tfToastFn(msg);
  }

  var TF_DRAWER_SELECTORS = ['cart-drawer', '#CartDrawer', '#cart-drawer', '.cart-drawer', '.drawer--cart', 'cart-notification', '#cart-notification'];

  function tfFindDrawer() {
    for (var i = 0; i < TF_DRAWER_SELECTORS.length; i++) {
      var el = document.querySelector(TF_DRAWER_SELECTORS[i]);
      if (el) return { el: el, sel: TF_DRAWER_SELECTORS[i] };
    }
    return null;
  }

  /* Voorkom dat de cart-drawer opent (we tonen een toast i.p.v. de drawer). */
  function tfCloseDrawer() {
    var d = tfFindDrawer();
    if (d) {
      if (typeof d.el.close === 'function') { try { d.el.close(); } catch (e) {} }
      d.el.classList.remove('active', 'is-open', 'open', 'drawer--is-open');
    }
    document.documentElement.classList.remove('cart-drawer-open');
    document.body.classList.remove('cart-drawer-open', 'drawer-open', 'js-drawer-open');
  }

  /* Ververs de inhoud van de cart-drawer zónder hem te openen, zodat het
     product er meteen in staat als de klant op het winkelwagen-icoon klikt. */
  function tfRefreshDrawer() {
    var found = tfFindDrawer();
    if (!found || !found.el.parentNode) return;
    fetch(window.location.pathname, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector(found.sel);
        var cur = tfFindDrawer();
        if (fresh && cur && cur.el.parentNode) {
          cur.el.parentNode.replaceChild(document.importNode(fresh, true), cur.el);
          tfCloseDrawer();
        }
      })
      .catch(function () {});
  }

  function init(root) {
    if (!root || root.__tfPdpInit) return;
    root.__tfPdpInit = true;

    var openDrawer = root.getAttribute('data-open-drawer') !== 'false';
    var ctaAdd = root.getAttribute('data-cta-add') || 'In winkelwagen';
    var ctaAdded = root.getAttribute('data-cta-added') || 'Toegevoegd ✓';
    var live = root.querySelector('[data-tf-live]');

    var qtyInput = root.querySelector('[data-tf-qty-input]');

    // ---------- Quantity ----------
    root.addEventListener('click', function (e) {
      var minus = e.target.closest('[data-tf-qty-minus]');
      var plus = e.target.closest('[data-tf-qty-plus]');
      if (minus) { e.preventDefault(); stepQty(-1, minus); }
      if (plus) { e.preventDefault(); stepQty(1, plus); }

      var thumb = e.target.closest('[data-tf-thumb]');
      if (thumb) { e.preventDefault(); selectThumb(thumb); }

      var variant = e.target.closest('[data-tf-variant]');
      if (variant) { e.preventDefault(); selectVariant(variant); }

      var accHead = e.target.closest('[data-tf-acc-head]');
      if (accHead) { e.preventDefault(); accHead.closest('[data-tf-acc-item]').classList.toggle('is-open'); }

      var add = e.target.closest('[data-tf-add]');
      if (add) { e.preventDefault(); addToCart(add); }
    });

    function getQty() {
      var v = parseInt(qtyInput && qtyInput.value, 10);
      return (!v || v < 1) ? 1 : v;
    }
    function stepQty(delta, btn) {
      // Kaart-stepper (gerelateerde producten) heeft eigen teller.
      var card = btn && btn.closest('[data-tf-card]');
      if (card) {
        var num = card.querySelector('[data-tf-qty-num]');
        if (!num) return;
        num.textContent = Math.max(1, (parseInt(num.textContent, 10) || 1) + delta);
        return;
      }
      if (!qtyInput) return;
      qtyInput.value = Math.max(1, getQty() + delta);
    }

    // ---------- Gallery ----------
    var mainImg = root.querySelector('[data-tf-main-img]');
    function selectThumb(thumb) {
      var src = thumb.getAttribute('data-full');
      if (mainImg && src) {
        mainImg.src = src;
        if (thumb.getAttribute('data-srcset')) mainImg.srcset = thumb.getAttribute('data-srcset');
      }
      root.querySelectorAll('[data-tf-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    }

    // ---------- Variants ----------
    var currentVariantId = root.getAttribute('data-variant-id');
    function selectVariant(btn) {
      currentVariantId = btn.getAttribute('data-variant-id');
      root.querySelectorAll('[data-tf-variant]').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      // update price if provided
      var price = btn.getAttribute('data-price');
      var priceEl = root.querySelector('[data-tf-price]');
      if (price && priceEl) priceEl.textContent = price;
    }

    // ---------- Add to cart ----------
    function addToCart(btn) {
      // Onderscheid de hoofd-koopknop van een kaart in "misschien ook interessant".
      var card = btn.closest('[data-tf-card]');
      var variantId, qty, title;
      if (card) {
        variantId = btn.getAttribute('data-variant-id') || card.getAttribute('data-variant-id');
        var cwrap = card.querySelector('[data-tf-qty]');
        var cnum = card.querySelector('[data-tf-qty-num]');
        qty = (cwrap && !cwrap.hasAttribute('hidden') && cnum) ? (parseInt(cnum.textContent, 10) || 1) : 1;
        title = card.getAttribute('data-product-title');
      } else {
        variantId = currentVariantId || root.getAttribute('data-variant-id');
        qty = getQty();
        var titleEl = root.querySelector('.tf-pdp__title');
        title = titleEl ? titleEl.textContent.trim() : '';
      }
      if (!variantId) return;
      var original = btn.getAttribute('data-label') || btn.textContent || ctaAdd;
      btn.classList.add('is-loading');
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty }] })
      })
        .then(function (res) { if (!res.ok) return res.json().then(function (j) { throw j; }); return res.json(); })
        .then(function () {
          btn.classList.remove('is-loading');
          btn.classList.add('is-added');
          btn.disabled = false;
          btn.textContent = ctaAdded;
          if (live) live.textContent = (title || 'Product') + ' toegevoegd aan winkelwagen.';
          tfToast(title ? (title + ' toegevoegd') : 'Toegevoegd aan winkelwagen');
          // Kaart-stepper tonen zodat klant snel meer kan toevoegen.
          if (card) { var w = card.querySelector('[data-tf-qty]'); if (w && w.hasAttribute('hidden')) w.removeAttribute('hidden'); }
          refreshCart();
          setTimeout(function () { btn.classList.remove('is-added'); btn.textContent = original; }, 1900);
        })
        .catch(function (err) {
          btn.classList.remove('is-loading');
          btn.disabled = false;
          btn.textContent = original;
          if (live) live.textContent = (err && err.description) ? err.description : 'Kon niet toevoegen.';
          console.warn('[tf-pdp] add failed', err);
        });
    }

    /* Geen cart-update broadcast (die opende de drawer leeg) — enkel de
       count-bubble bijwerken en een eventueel geopende drawer sluiten. */
    function refreshCart() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('.cart-count-bubble span:first-child, [data-cart-count], .cart-count, .site-header__cart-count')
            .forEach(function (n) { n.textContent = cart.item_count; });
          tfCloseDrawer();
          // Drawer-inhoud verversen zodat het product er meteen in staat.
          tfRefreshDrawer();
        })
        .catch(function () {});
    }

    // ---------- Klant-video-slider ----------
    var vslider = root.querySelector('[data-tf-vslider]');
    if (vslider) initVideoSlider(vslider);

    function initVideoSlider(sl) {
      var track = sl.querySelector('[data-tf-vtrack]');
      var slides = [].slice.call(sl.querySelectorAll('[data-tf-vslide]'));
      var dots = [].slice.call(sl.querySelectorAll('[data-tf-vdot]'));
      var prev = sl.querySelector('[data-tf-vprev]');
      var next = sl.querySelector('[data-tf-vnext]');
      var idx = 0;
      if (!track || !slides.length) return;

      function playActive() {
        slides.forEach(function (slide, i) {
          var v = slide.querySelector('video');
          if (!v) return;
          if (i === idx) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
          else { try { v.pause(); } catch (e) {} }
        });
      }
      function setIdx(i) {
        idx = Math.max(0, Math.min(slides.length - 1, i));
        dots.forEach(function (d, di) { d.classList.toggle('is-active', di === idx); });
        playActive();
      }
      function scrollToIdx(i) {
        var s = slides[Math.max(0, Math.min(slides.length - 1, i))];
        if (s) track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { scrollToIdx(idx - 1); });
      if (next) next.addEventListener('click', function () { scrollToIdx(idx + 1); });
      dots.forEach(function (d) {
        d.addEventListener('click', function () { scrollToIdx(parseInt(d.getAttribute('data-i'), 10) || 0); });
      });

      // geluid aan/uit per video
      sl.addEventListener('click', function (e) {
        var mb = e.target.closest('[data-tf-vmute]');
        if (!mb) return;
        var slide = mb.closest('[data-tf-vslide]');
        var v = slide && slide.querySelector('video');
        if (!v) return;
        v.muted = !v.muted;
        var on = mb.querySelector('[data-tf-vmute-on]');
        var off = mb.querySelector('[data-tf-vmute-off]');
        if (on) on.hidden = !v.muted;
        if (off) off.hidden = v.muted;
        if (!v.muted) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
      });

      // actieve slide bepalen tijdens scrollen/swipen
      var raf;
      track.addEventListener('scroll', function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var center = track.scrollLeft + track.clientWidth / 2;
          var best = 0, bestd = Infinity;
          slides.forEach(function (s, i) {
            var c = (s.offsetLeft - track.offsetLeft) + s.clientWidth / 2;
            var dd = Math.abs(c - center);
            if (dd < bestd) { bestd = dd; best = i; }
          });
          if (best !== idx) setIdx(best);
        });
      }, { passive: true });

      // pauzeer als de slider buiten beeld is
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (ents) {
          ents.forEach(function (en) {
            if (!en.isIntersecting) { slides.forEach(function (s) { var v = s.querySelector('video'); if (v) { try { v.pause(); } catch (e) {} } }); }
            else { playActive(); }
          });
        }, { threshold: 0.25 });
        io.observe(sl);
      }

      setIdx(0);
    }

    // ---------- Mobile sticky bar visibility ----------
    var sticky = root.querySelector('[data-tf-sticky]');
    var buyAnchor = root.querySelector('[data-tf-buy]');
    if (sticky && buyAnchor && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) sticky.classList.remove('is-visible');
          else sticky.classList.add('is-visible');
        });
      }, { threshold: 0 });
      io.observe(buyAnchor);
    }
  }

  function boot() { document.querySelectorAll('[data-tf-pdp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-tf-pdp]');
    if (el) init(el);
  });
})();
